// extracted by mini-css-extract-plugin
var _1 = "ra-shortcut-links";
var _2 = "ra-shortcut-links-container";
var _3 = "ra-shortcut-links-draggable";
export { _1 as "shortcutLinksCls", _2 as "shortcutLinksContainerCls", _3 as "shortcutLinksDraggableCls" }
